import Layout from "@/views/layout/Index";

export const EvaluationRouter = [
  {
    path: "/evaluation",
    name: "evaluation",
    component: Layout,
    meta: { title: "我的测评", icon: "fa-group" },
    children: [
      {
        path: "project/list",
        component: () => import("@views/evaluation/ProjectList"),
        name: "evaluation-project",
        meta: { title: "项目列表", icon: "fa-codepen" }
      },
      {
        path: "project/standard/:projectId",
        component: () => import("@/views/evaluation/Standard"),
        name: "project-standard",
        meta: { title: "企业方案列表", icon: "fa-codepen", auth: false },
        hidden: true
      },
      {
        path: "fenc/model/:projectId",
        component: () => import("@views/evaluation/fenc/Model"),
        name: "fenc-model",
        meta: { title: "胜任力模型", icon: "fa-codepen", auth: false },
        hidden: true
      },
      {
        path: "project/person/:projectId",
        component: () => import("@/views/evaluation/Person"),
        name: "project-person",
        meta: { title: "个人方案列表", icon: "fa-codepen", auth: false },
        hidden: true
      },
      {
        path: "fenc/list",
        component: () => import("@/views/evaluation/fenc/List"),
        name: "fenc-list",
        meta: { title: "胜任力", icon: "fa-first-order" }
      },
      {
        path: "fenc-manage/list",
        component: () => import("@/views/evaluation/fenc-manage/List"),
        name: "fenc-manage-list",
        meta: { title: "胜任力管理版", icon: "fa-first-order" }
      },
      {
        path: "customer/list",
        component: () => import("@/views/enterprise/customer/List"),
        name: "customer-list",
        meta: { title: "客户列表", icon: "fa-first-order" }
      },
      {
        path: "fenc/detail/:projectId",
        component: () => import("@/views/evaluation/fenc/Detail"),
        name: "fenc-detail",
        meta: { title: "企业方案列表", icon: "fa-codepen", auth: false },
        hidden: true
      },
      {
        path: "fenc/manage/detail/:projectId",
        component: () => import("@/views/evaluation/fenc-manage/Detail"),
        name: "fenc-manage-detail",
        meta: { title: "胜任力管理版详情", icon: "fa-codepen" },
        hidden: true
      },
      {
        path: "scheme/list",
        component: () => import("@/views/evaluation/Scheme"),
        name: "evaluation-scheme",
        meta: { title: "方案列表", icon: "fa-first-order" }
      },
      {
        path: "form/list",
        component: () => import("@views/evaluation/FormList"),
        name: "evaluation-form",
        meta: { title: "表单列表", icon: "fa-css3" }
      },
      {
        path: "form/save",
        component: () => import("@views/evaluation/FormSave"),
        name: "evaluation-form-save",
        meta: { title: "表单添加", icon: "fa-user-plus" },
        hidden: true
      },
      {
        path: "order/count",
        component: () => import("@views/evaluation/order/OrderCount"),
        name: "order-count",
        meta: { title: "项目账单", icon: "fa-user-plus" }
      },
      {
        path: "order/report/list",
        component: () => import("@views/evaluation/order/ReportList"),
        name: "order-report-list",
        hidden: true,
        meta: { title: "项目报告账单", icon: "fa-user-plus",auth:false }
      }
    ]
  }
];


